import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormLabel, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getErrors, isValid } from '@totalsoft/pure-validations-react';
import { Autocomplete } from '@totalsoft/rocket-ui';

const DocumentTemplateSignatureHeaderComponent = ({
  documentTemplate,
  signatureTypes,
  requiredDocTypes,
  onSelectedClick,
  onImplicitClick,
  onPropertyChanged,
  onDocumentTemplateNeedsSigningChanged,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Checkbox
            checked={documentTemplate.needsSigning ? documentTemplate.needsSigning : false}
            onClick={event => onDocumentTemplateNeedsSigningChanged(event.target.checked)}
          />
          <FormLabel>{t('DocumentTemplate.NeedsSigning')}</FormLabel>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            fullWidth
            isClearable={true}
            isSearchable={true}
            value={documentTemplate.requiredDocTypeId}
            options={requiredDocTypes}
            label={t('DocumentTemplate.RequiredDocument')}
            onChange={event => onPropertyChanged('requiredDocTypeId', event)}
            simpleValue
            error={!isValid(validation.requiredDocTypeId)}
            helperText={getErrors(validation.requiredDocTypeId)}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('DocumentTemplate.Selected')}</TableCell>
                <TableCell>{t('DocumentTemplate.SignatureName')}</TableCell>
                <TableCell>{t('DocumentTemplate.Implicit')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {signatureTypes.map(signature => {
                const signatureSelected =
                  documentTemplate &&
                  documentTemplate.documentTemplateXSignatures &&
                  documentTemplate.documentTemplateXSignatures.find(item => item.signatureId === signature.id);
                return (
                  <TableRow hover key={signature.id}>
                    <TableCell>
                      <Checkbox checked={!!signatureSelected} onClick={event => onSelectedClick(event.target.checked, signature.id)} />
                    </TableCell>
                    <TableCell>{signature.name}</TableCell>
                    <TableCell>
                      <Checkbox
                        checked={signatureSelected ? signatureSelected.implicit : false}
                        disabled={!signatureSelected}
                        onClick={event => onImplicitClick(event.target.checked, signature.id)}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  );
};

DocumentTemplateSignatureHeaderComponent.propTypes = {
  documentTemplate: PropTypes.object,
  signatureTypes: PropTypes.array.isRequired,
  requiredDocTypes: PropTypes.array.isRequired,
  onSelectedClick: PropTypes.func,
  onImplicitClick: PropTypes.func,
  onPropertyChanged: PropTypes.func,
  onDocumentTemplateNeedsSigningChanged: PropTypes.func,
  validation: PropTypes.object.isRequired
};

export default DocumentTemplateSignatureHeaderComponent;
